module.exports = __webpack_public_path__ + "img/hontai_RichBlack.db03eb79.png";